import featureTooltip from './cv-tooltip/feature-tooltip.directive'
import featureVideo from './cv-video/feature-video.directive'

const module = angular.module('mpa.components.featureiconlist', [])

module.directive('featureTooltip', featureTooltip).directive('featureVideo', featureVideo)

export default module.name
